import React from 'react'
import { 
  Step, 
  Typography, 
  Stepper, 
  StepLabel, 
  Grid, 
  Divider,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import SaveIcon from '@material-ui/icons/Save'

import { CustomButton } from 'components'
import { FormLesoesTraumaticas } from './LesoesTraumaticas/FormLesoesTraumaticas'
import { FormFenomenosCadavericos } from './FenomenosCadavericos/FormFenomenosCadavericos'
import { FormAnalisesInternas } from './AnalisesInternas/FormAnalisesInternas'
import { FormCaracteristicas } from './Caracteristicas/FormCaracteristicas'
import { FormConclusao } from './Conclusao/FormConclusao'
import { Quesitos } from '../components/Quesitos/Quesitos'
import { FormTatuagensECicatrizes } from './FormTatuagensECicatrizes'

import { useStyles } from './Form.styles'
import { useExameNecroscopicoForm } from './useExameNecroscopicoForm'

export const Form = (props) => {
  const { exameNecroscopico, setExameNecroscopico } = props
  
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles()

  const {
    processando,
    activeStep,
    steps,
    setLesoesForm,
    setCicatrizesForm,
    setSVGTatuagensForm,
    setSvgLesoesForm,
    hideNextButton,
    setHideNextButton,
    caracteristicasForm,
    conclusaoForm,
    quesitosForm,
    getStepTitle,
    formError,
    handleBack,
    handleNext,
    router,
  } = useExameNecroscopicoForm(exameNecroscopico, setExameNecroscopico)

  return (
    <div className={classes.root}>
      <div className={classes.stepperContainer}>
        <Stepper 
          activeStep={activeStep} 
          alternativeLabel
          className={classes.stepper}
        >
          {steps.map((label) => (
            <Step key={label} className={classes.step}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      
      <Grid container justifyContent="space-between" spacing={3} className={classes.contentSplitter}>
        <Grid item xs={12} className={classes.downContainer}>
          <Grid container justifyContent="space-between" spacing={1}>
            <Grid item xs={12}>
              <Typography component="h4" variant="h4">
                {getStepTitle()}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} style={{ padding: '20px 0' }}>
              {activeStep === 0 && (
                <FormCaracteristicas form={caracteristicasForm} exameNecroscopico={exameNecroscopico} />
              )}
              {activeStep === 1 && exameNecroscopico?.exReal?.exSol?.cadavs && (
                <FormTatuagensECicatrizes 
                  idExameRealizado={exameNecroscopico.id} 
                  idCadaver={exameNecroscopico.exReal.exSol.cadavs[0].id} 
                  setCicatrizesForm={setCicatrizesForm} 
                  setSVGTatuagensForm={setSVGTatuagensForm} 
                />
              )}
              {activeStep === 2 && exameNecroscopico?.exReal?.exSol?.cadavs && (
                <FormFenomenosCadavericos 
                  idExameRealizado={exameNecroscopico.id} 
                  idCadaver={exameNecroscopico.exReal.exSol.cadavs[0].id} 
                  exameNecroscopico={exameNecroscopico} 
                  setHideNextButton={setHideNextButton} 
                  router={router} 
                />
              )}
              {activeStep === 3 && exameNecroscopico?.exReal?.exSol?.cadavs && (
                <FormLesoesTraumaticas 
                  idExameRealizado={exameNecroscopico.id} 
                  setSvgLesoesForm={setSvgLesoesForm} 
                  idCadaver={exameNecroscopico.exReal.exSol.cadavs[0].id} 
                  setHideNextButton={setHideNextButton} 
                  router={router} 
                  setLesoesForm={setLesoesForm} 
                />
              )}
              {activeStep === 4 && (
                <FormAnalisesInternas 
                  exameNecroscopico={exameNecroscopico} 
                  setHideNextButton={setHideNextButton} 
                  router={router} 
                />
              )}
              {activeStep === 5 && (
                <FormConclusao exameNecroscopico={exameNecroscopico} form={conclusaoForm} />
              )}
              {activeStep === 6 && (
                <Quesitos 
                  formState={quesitosForm.formState} 
                  setFormState={quesitosForm.setFormState} 
                  processandoExame={processando} 
                  exame={exameNecroscopico.exReal} 
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            {!hideNextButton && (
              <Grid item xs={12}>
                <Grid container justify="space-between" spacing={1} className={classes.buttons}>
                  <Grid item>
                    {activeStep === 0 ? (
                      <CustomButton
                        variant="outlined"
                        onClick={() => router.history.goBack()}
                        startIcon={<ArrowBackIcon />}
                      >
                        Voltar
                      </CustomButton>
                    ) : (
                      <CustomButton
                        variant="outlined"
                        onClick={handleBack}
                        startIcon={<NavigateBeforeIcon />}
                      >
                        Etapa Anterior
                      </CustomButton>
                    )}
                  </Grid>
                  <Grid item>
                    <CustomButton
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      disabled={formError()}
                      isLoading={processando}
                      startIcon={activeStep === steps.length - 1 ? <SaveIcon /> : <NavigateNextIcon />}
                    >
                      {activeStep === steps.length - 1 ? 'Finalizar formulário' : 'Próxima Etapa'}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
